import React from 'react'
import {
    BottomNavigation,
    BottomNavigationAction,
    Paper,
    Tooltip,
} from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import Homeimg from '../../assets/images/home_3.svg'
import SolarPlant from '../../assets/images/solar plant_3.svg'
import Settingsicon from '../../assets/images/settings.svg'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import FeedIcon from '@mui/icons-material/FeedOutlined'
import usePermission from '../../hooks/usePermission'

const MobileBottomNav = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { can, is } = usePermission()

    const navItems = [
        {
            label: 'Home',
            value: '/dashboard',
            icon: <img src={Homeimg} alt="home icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
        },
        {
            label: 'Solar Plant List',
            value: '/solarplantlist',
            icon: <img src={SolarPlant} alt="solarplant icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
            permissions: ['entity.all', 'plant.read', 'plant.create', 'plant.update', 'plant.delete'],
        },
        {
            label: 'Issue Management',
            value: '/issue-management',
            icon: <AssignmentIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['issue.all', 'issue.read', 'issue.create', 'issue.update', 'issue.delete'],
        },
        {
            label: 'DGR',
            value: '/daily-generation-report',
            icon: <AnalyticsIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['daily_generation_report.all', 'daily_generation_report.read', 'daily_generation_report.create', 'daily_generation_report.update', 'daily_generation_report.delete'],
        },
        {
            label: 'Billing Records',
            value: '/billing-records',
            icon: <ReceiptLongIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['invoice.all', 'invoice.read', 'invoice.download'],
        },
        {
            label: 'Invoice Records',
            value: '/invoice-records',
            icon: <FeedIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['invoice.all', 'invoice.read', 'invoice.create', 'invoice.update', 'invoice.zoho', 'invoice.email', 'invoice.download'],
        },
        {
            label: 'Settings',
            value: '/settings',
            icon: <img src={Settingsicon} alt="Settings icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
            permissions: ['settings.all', 'user.all', 'settings.listOfUsers', 'user.read', 'user.create', 'settings.organizations.read', 'organization.all', 'settings.roles.read', 'role.read', 'settings.entities.read', 'settings.reports', 'settings.changePassword', 'settings.emailSettings'],
        },
    ]

    const filteredItems = navItems.filter((item) => {
        if (item.permissions) {
            return item.permissions.some((p) => can(p))
        }
        return true
    })

    //current active tab based on pathname
    const getCurrentValue = () => {
        const pathname = location.pathname

        //special case for technical and businessview
        if (pathname.includes('/plantTechnicalView') || pathname.includes('/plantBusinessView')) {
            return '/solarplantlist'
        }

        const matchedItem = filteredItems.find((item) =>
            pathname.startsWith(item.value)
        )
        return matchedItem?.value || '/dashboard'
    }

    const currentValue = getCurrentValue()
    //console.log('MobileBottomNav Render:', { currentValue, pathname: location.pathname })

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200, // Reduced from 1400 to appear below modals (1300)
                elevation: 10,
                boxShadow: '0 -2px 10px rgba(0,0,0,0.1)', // Added top shadow
            }}
        >
            <BottomNavigation
                showLabels={false}
                value={currentValue}
                onChange={(event, newValue) => {
                    navigate(newValue)
                }}
                sx={{
                    height: 64,
                    '& .MuiBottomNavigationAction-root': {
                        minWidth: filteredItems.length <= 5 ? 'auto' : '80px',
                        flex: filteredItems.length <= 5 ? '1 1 auto' : '0 0 auto',
                        px: 2,
                        color: '#666',
                        borderTop: '3px solid transparent',
                        transition: 'all 0.3s ease',
                        '&.Mui-selected': {
                            color: '#1976d2',
                            borderTop: '3px solid #1976d2',
                            '& .MuiSvgIcon-root': {
                                color: '#1976d2',
                            },
                            '& img': {
                                filter: 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(1352%) hue-rotate(192deg) brightness(95%) contrast(92%)',
                            },
                        },
                    },
                    display: 'flex',
                    overflowX: filteredItems.length > 5 ? 'auto' : 'hidden',
                    justifyContent: filteredItems.length <= 5 ? 'space-around' : 'flex-start',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                {filteredItems.map((item) => {
                    const isActive = currentValue === item.value
                    return (
                        <Tooltip title={item.label} key={item.value} arrow>
                            <BottomNavigationAction
                                label={item.label}
                                value={item.value}
                                icon={item.icon}
                            />
                        </Tooltip>
                    )
                })}
            </BottomNavigation>
        </Paper>
    )
}

export default MobileBottomNav
